// eslint-disable-next-line import/no-extraneous-dependencies
import {
  BlacklistStatus,
  getDepotTypes,
  getOrderSubTypes,
} from 'pando-constants';

const { STANDARD, VENDOR } = getDepotTypes();
const { INBOUND_VENDOR, INBOUND_RETURN } = getOrderSubTypes();

export const deliveryList = [
  { id: 1, name: 'FTL', tlabel: 'INDENT_FTL' },
  { id: 2, name: 'PTL', tlabel: 'INDENT_PTL' },
];
export const activecontractsHeaders = [
  { id: 0, title: 'Transporter', tlabel: 'TRANSPORTER', truncateOn: 20, show: true },
  { id: 1, title: 'Transporter ref id', tlabel: 'TRANSPORTER_REF_ID', truncateOn: 20, show: true },
  { id: 2, title: 'Vehicle type', tlabel: 'VEHICLE_TYPE', truncateOn: 20, show: true },
  { id: 3, title: 'Base freight', tlabel: 'BASE_FREIGHT', truncateOn: 20, show: true },
];
export const insuranceThreshold = [
  { value: 1, label: 'Individual Threshold' },
  { value: 2, label: 'Overall Threshold' },
];

export const chargeText = {
  INDIVIDUAL: 'Add individual charge',
  OVERALL: 'Add overall charge',
};

export const chargeSettingsHeader = {
  INDIVIDUAL: 'Individual charge settings',
  OVERALL: 'Overall charge settings',
};

export const thresholdType = {
  INDIVIDUAL_THRESHOLD: 1,
  OVERALL_THRESHOLD: 2,
};

export const chargeList = [
  { id: 1, name: 'Shortage', label: 'shortage' },
  { id: 2, name: 'Damage', label: 'damage' },
  { id: 3, name: 'Carton Damage', label: 'carton_damage' },
];

export const deliveryListFilter = [
  {
    group_type: '',
    options: [
      {
        id: -1,
        display_label: 'All Delivery Types',
        tlabel: 'INDENT_ALL_DELIVERY_TYPES',
        group_type: -1,
      },
    ],
    icon: '',
  },
  {
    group_type: 'FTL',
    options: [
      {
        id: 1,
        display_label: 'All',
        tag_display_label: 'FTL',
        delivery_type: 'FTL',
      },
      {
        id: 2,
        display_label: 'ROAD',
        tag_display_label: 'FTL - ROAD',
        delivery_type: 'FTL',
        delivery_type_and_mode: 1,
      },
      {
        id: 3,
        display_label: 'AIR',
        tag_display_label: 'FTL - AIR',
        delivery_type: 'FTL',
        delivery_type_and_mode: 3,
      },
      {
        id: 4,
        display_label: 'RAIL',
        tag_display_label: 'FTL - RAIL',
        delivery_type: 'FTL',
        delivery_type_and_mode: 4,
      },
    ],
    icon: '',
  },
  {
    group_type: 'PTL',
    options: [
      {
        id: 5,
        display_label: 'All',
        tag_display_label: 'PTL',
        delivery_type: 'PTL',
      },
      {
        id: 6,
        display_label: 'ROAD',
        tag_display_label: 'PTL - ROAD',
        delivery_type: 'PTL',
        delivery_type_and_mode: 5,
      },
      {
        id: 7,
        display_label: 'AIR',
        tag_display_label: 'PTL - AIR',
        delivery_type: 'PTL',
        delivery_type_and_mode: 7,
      },
      {
        id: 8,
        display_label: 'RAIL',
        tag_display_label: 'PTL - RAIL',
        delivery_type: 'PTL',
        delivery_type_and_mode: 8,
      },
    ],
    icon: '',
  },
];

export const deliveryName = { FTL: 'FTL', PTL: 'PTL' };

export const freightTypeList = [
  { id: 0, name: 'EX-Works', tlabel: 'INDENT_EX_WORKS' },
  { id: 1, name: 'Party Collect', tlabel: 'INDENT_PARTY_COLLECT' },
];

export const loaders = [
  { id: 0, name: 'Not available', tlabel: 'INDENT_NOT_AVAILABLE' },
  { id: 1, name: 'Available', tlabel: 'INDENT_AVAILABLE' },
];

export const paidBy = [
  { id: 0, name: 'Don’t add to Invoice', tlabel: 'INDENT_DONT_ADD_INVOICE' },
  { id: 1, name: 'Add to Invoice', tlabel: 'INDENT_ADD_INVOICE' },
];

export const orderTypes = [
  {
    name: 'CONTRACT',
    id: 0,
    view_permission: 'view_contract_indent',
    create_permission: 'create_contract_indent',
    update_permission: 'update_contract_indent',
    label: 'Contract',
    iconName: 'status_contract',
    tlabel: 'INDENT_CONTRACT',
  },
  {
    name: 'OPEN',
    id: 1,
    view_permission: 'view_open_indent',
    create_permission: 'create_open_indent',
    update_permission: 'update_open_indent',
    label: 'Open',
    iconName: 'status_open',
    tlabel: 'INDENT_OPEN',
  },
  {
    name: 'NO FREIGHT',
    id: 2,
    view_permission: 'view_no_freight_indent',
    create_permission: 'create_no_freight_indent',
    update_permission: 'update_no_freight_indent',
    label: 'No Freight',
    iconName: 'status_nofreight',
    tlabel: 'INDENT_NO_FREIGHT',
  },
  {
    name: 'MARKET',
    id: 3,
    view_permission: 'view_market_indent',
    create_permission: 'create_market_indent',
    update_permission: 'update_market_indent',
    label: 'Market',
    iconName: 'status_market',
    tlabel: 'INDENT_MARKET',
  },
];

export const contractTypes = [
  { id: 1, name: 'Per Trip' },
  { id: 2, name: 'Per Ton' },
  { id: 3, name: 'Per Kg' },
  { id: 4, name: 'Per CFT' },
  { id: 5, name: 'Per Package' },
  { id: 6, name: 'Per Case' },
  { id: 7, name: 'Per Box' },
  { id: 8, name: 'Per KM' },
];

export const OpenIndentcontractTypes = [
  { id: 1, name: 'Per Trip' },
  { id: 2, name: 'Per Ton' },
  { id: 3, name: 'Per Kg' },
  { id: 4, name: 'Per CFT' },
  { id: 5, name: 'Per Package' },
  { id: 6, name: 'Per Case' },
  { id: 7, name: 'Per Box' },
];

export const contractType = {
  city: 1,
  point: 4,
};

export const InboundType = {
  return: INBOUND_RETURN,
  vendorDepot: INBOUND_VENDOR,
};

export const depotType = {
  vendorDepot: VENDOR,
  depot: STANDARD,
};

export const Menu = [
  {
    id: 0,
    name: 'Outbound',
    tlabel: 'INDENT_OUTBOUND',
  },
  {
    id: 1,
    name: 'Inbound',
    tlabel: 'INDENT_INBOUND',
  },
  {
    id: 2, // for CT listing
    name: 'Indents',
  },
];
export const deliveryPendingReasonsMapping = {
  // status 1,2 relates to Material invoice NA
  1: 'Material Invoice N/A',
  2: 'Material Invoice N/A',
  3: 'EPOD N/A',
  4: 'OTP Verification',
  6: 'GRN Approval Pending',
};
// permission - OUTBOUND, inbound_permission - INBOUND
export const indentButtonPermission = {
  INDENT_BULK_UPLOAD: {
    permission: 'indent_bulk_upload',
    inbound_permission: 'inbound_create_contract_indent',
  },
  INDENT_DIRECT_DELIVERY_INDENT_BULK_UPLOAD: {
    permission: 'create_direct_delivery_indent',
    inbound_permission: 'inbound_create_direct_delivery_indent',
  },
  INDENT_GRN_BULK_UPLOAD: {
    permission: ['grn_bulk_upload', 'update_grn'],
    inbound_permission: ['inbound_grn_bulk_upload', 'update_grn'],
  },
  INDENT_MATERIAL_BULK_UPLOAD: {
    permission: 'indent_add_materials',
    inbound_permission: 'inbound_indent_add_materials',
  },
  INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD: {
    permission: ['import_material_invoice_grn', 'update_grn'],
    inbound_permission: ['inbound_import_material_invoice_grn', 'update_grn'],
  },
  INDENT_MATERIAL_DELETE_UPLOAD: {
    permission: 'indent_material_bulk_delete',
    inbound_permission: 'indent_material_bulk_delete',
  },
  INDENT_DIRECT_DISPATCH_BULK_UPLOAD: {
    permission: 'create_direct_dispatch_indent',
    inbound_permission: 'inbound_import_direct_dispatch',
  },
  CHARGEABLE_WEIGHT_BULK_UPLOAD: {
    permission: 'import_chargeable_weight',
    inbound_permission: 'import_chargeable_weight',
  },
  LR_BULK_UPLOAD: {
    permission: 'lr_bulk_upload',
    inbound_permission: 'inbound_lr_bulk_upload',
  },
};

export const indentButtons = [
  {
    id: 7,
    type: 'piAgent',
    show: true,
    class: 'header_sbtn',
    emitMethod: 'routeToAiAgent',
    feature: 'shipment_intelligence',
  },
  {
    id: 1,
    name: 'Rejections',
    tlabel: 'INDENT_REJECTIONS',
    show: false,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'rejectDownload',
  },
  {
    id: 6,
    name: 'Actions',
    tlabel: 'INDENT_ACTIONS',
    show: true,
    class: 'header_sbtn',
    hidePermission: 'hide_indent_actions',
    feature: 'show_indent_actions',
    disabled: false,
    dropdownList: [
      {
        type: 'button',
        name: 'E-LR Download',
        emitMethod: 'handleClose',
        feature: 'download_multi_e_lr',
      },
    ],
  },
  {
    id: 2,
    name: 'Upload',
    tlabel: 'INDENT_UPLOAD',
    show: true,
    class: 'header_sbtn',
    hidePermission: 'hide_indent_upload',
    disabled: false,
    dropdownList: [
      {
        type: 'upload',
        name: 'Indent Bulk Upload',
        tlabel: 'INDENT_BULK_UPLOAD',
        permission: indentButtonPermission.INDENT_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_BULK_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'indentBulkSampleDownload',
        uploadEmitMethod: 'bulkUpload',
      },
      {
        type: 'upload',
        name: 'Direct Delivery Indent Bulk Upload',
        tlabel: 'INDENT_DIRECT_DELIVERY_INDENT_BULK_UPLOAD',
        permission: indentButtonPermission.INDENT_DIRECT_DELIVERY_INDENT_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_DIRECT_DELIVERY_INDENT_BULK_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'directDeliveryIndentBulkSampleDownload',
        uploadEmitMethod: 'directDeliveryBulkUpload',
      },
      {
        type: 'upload',
        name: 'GRN Bulk Upload',
        tlabel: 'INDENT_GRN_BULK_UPLOAD',
        permission: indentButtonPermission.INDENT_GRN_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_GRN_BULK_UPLOAD.inbound_permission,
        sampleFileName: 'GRNBulkUpload.xlsx',
        uploadEmitMethod: 'podBulkUpload',
      },
      {
        type: 'upload',
        name: 'POD Bulk Upload',
        tlabel: 'INDENT_POD_BULK_UPLOAD',
        sampleFileName: 'podSample.xlsx',
        uploadEmitMethod: 'consigneePodFileUpload',
      },
      {
        type: 'upload',
        name: 'Material Bulk Upload',
        tlabel: 'INDENT_MATERIAL_BULK_UPLOAD',
        permission: indentButtonPermission.INDENT_MATERIAL_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_MATERIAL_BULK_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'indentMaterialSampleDownload',
        uploadEmitMethod: 'materialBulkUpload',
      },
      {
        type: 'upload',
        name: 'Material Invoice With GRN Bulk Upload',
        tlabel: 'INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD',
        permission: indentButtonPermission.INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'indentMaterialInvoiceGrnSampleDownload',
        uploadEmitMethod: 'indentMaterialInvoiceGrnBulkUpload',
      },
      {
        type: 'upload',
        name: 'Material Delete Bulk Upload',
        tlabel: 'INDENT_MATERIAL_DELETE_UPLOAD',
        permission: indentButtonPermission.INDENT_MATERIAL_DELETE_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_MATERIAL_DELETE_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'indentMaterialDeleteSampleDownload',
        uploadEmitMethod: 'indentMaterialDeleteUpload',
      },
      {
        type: 'upload',
        name: 'Direct Dispatch Bulk Upload',
        tlabel: 'INDENT_DIRECT_DISPATCH_BULK_UPLOAD',
        permission: indentButtonPermission.INDENT_DIRECT_DISPATCH_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.INDENT_DIRECT_DISPATCH_BULK_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'indentDirectDispatchSampleDownload',
        uploadEmitMethod: 'indentDirectDispatchBulkUpload',
      },
      {
        type: 'upload',
        name: 'Chargeable Weight Bulk Upload',
        tlabel: 'CHARGEABLE_WEIGHT_BULK_UPLOAD',
        permission: indentButtonPermission.CHARGEABLE_WEIGHT_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.CHARGEABLE_WEIGHT_BULK_UPLOAD.inbound_permission,
        sampleFileName: 'chargeableWeightUploadSample.xlsx',
        uploadEmitMethod: 'chargeableWeightBulkUpload',
      },
      {
        type: 'upload',
        name: 'LR Bulk Upload',
        tlabel: 'LR_BULK_UPLOAD',
        permission: indentButtonPermission.LR_BULK_UPLOAD.permission,
        inbound_permission: indentButtonPermission.LR_BULK_UPLOAD.inbound_permission,
        sampleFileEmitMethod: 'lrSampleDownload',
        uploadEmitMethod: 'lrBulkUpload',
      },
    ],
  },
  {
    id: 3,
    name: 'Add',
    tlabel: 'INDENT_ADD',
    show: false,
    class: 'header_pbtn',
    disabled: false,
    routerLinkName: 'CreateOrder',
    params: { type: 0 },
    GAEventConstants: ['Click', 'Add Outbound'],
  },
  {
    id: 4,
    name: 'Add Inbound',
    tlabel: 'INDENT_ADD_INBOUND',
    show: false,
    class: 'header_pbtn inboundbutton',
    dropdownClass: 'inbounddropdown',
    disabled: false,
    routerLinkName: 'CreateOrder',
    params: { type: 1 },
    config: 'inboundConfig',
    childConfigs: ['return_flow', 'vendor_flow'],
    GAEventConstants: ['Click', 'Add Inbound'],
  },
  {
    id: 5,
    name: 'Generate Manifest',
    tlabel: 'INDENT_GENERATE_MANIFEST',
    show: true,
    class: 'header_pbtn',
    disabled: false,
    emitMethod: 'openManifest',
    permission: 'generate_manifest',
  },
];

export const filters = {
  DEPOT: 'Depot',
  GATE: 'Gate',
  INDENT_TYPE: 'Indent Type',
  MOVEMENT: 'Movement',
  DELIVERY_TYPE: 'Delivery Type',
  DELIVERY_TYPE_FILTER: 'Delivery Type Filter',
  DATE_PICKER: 'Date Picker',
  CREATION_DATE: 'Creation Date',
  VEH_DATE: 'Vehicle Requirement Date',
  SCH_DATE: 'Scheduled Shipping Date',
  DISPATCH_DATE: 'Dispatched Date',
  STATUS: 'Status',
  MATERIAL_PRIORITY: 'Material Priority',
  UTILIZATION_CHECK: 'Utilization Check',
};

export const movementTypeMenu = [
  { id: -1, name: 'All Movement Types', tlabel: 'INDENT_ALL_MOVEMENT_TYPES' },
  { id: 1, name: 'Secondary', tlabel: 'INDENT_SECONDARY' },
  { id: 2, name: 'Primary', tlabel: 'INDENT_PRIMARY' },
  { id: 3, name: 'Vendor', check_config: 'vendor_flow', tlabel: 'INDENT_VENDOR' },
  { id: 4, name: 'Returns', check_config: 'return_flow', tlabel: 'INDENT_RETURNS' },
];
export const BillToPartyOption = [
  { id: 1, name: 'Source', tlabel: 'SOURCE_DEPOT' },
  { id: 2, name: 'Destination', tlabel: 'DESTINATION_DEPOT' },
  { id: 3, name: 'Central HO', check_config: 'central ho', tlabel: 'CENTRAL_HO_DEPOT' }
];

export const settingsMovement = [
  { type: 2, name: 'Primary' },
  { type: 1, name: 'Secondary' },
  { type: 3, name: 'Vendor', check_config: 'vendor_flow' },
  { type: 4, name: 'Return', check_config: 'return_flow' },
];

export const orderStatus = [
  {
    id: 0,
    name: 'Select All',
    tlabel: 'INDENT_ALL_STATUSES',
  },
  {
    id: 1,
    name: 'Indented',
    tlabel: 'INDENT_INDENTED_STATUS',
  },
  {
    id: 27,
    name: 'Draft',
    tlabel: 'INDENT_DRAFT_STATUS',
  },
  {
    id: 2,
    name: 'Transporter Rejected',
    tlabel: 'INDENT_TRANSPORTER_REJECTED_STATUS',
  },
  {
    id: 3,
    name: 'Accepted',
    tlabel: 'INDENT_ACCEPTED_STATUS',
  },
  {
    id: 22,
    name: 'Arrival Due',
    tlabel: 'INDENT_ARRIVAL_DUE_STATUS',
  },
  {
    id: 4,
    name: 'Assigned',
    tlabel: 'INDENT_ASSIGNED_STATUS',
  },
  {
    id: 24,
    name: 'Reported',
    tlabel: 'INDENT_REPORTED_STATUS',
  },
  {
    id: 5,
    name: 'Arrived',
    tlabel: 'INDENT_ARRIVED_STATUS',
  },
  {
    id: 16,
    name: 'Inspection Rejected',
    tlabel: 'INDENT_INSPECTION_REJECTED_STATUS',
  },
  {
    id: 17,
    name: 'Load Started',
    tlabel: 'INDENT_LOAD_STARTED_STATUS',
  },
  {
    id: 18,
    name: 'Load Ended',
    tlabel: 'INDENT_LOAD_ENDED_STATUS',
  },
  {
    id: 6,
    name: 'Dispatched',
    tlabel: 'INDENT_DISPATCHED_STATUS',
  },
  {
    id: 7,
    name: 'Delivered',
    tlabel: 'INDENT_DELIVERED_STATUS',
  },
  {
    id: 23,
    name: 'Delivery Pending',
    tlabel: 'INDENT_DELIVERY_PENDING_STATUS',
  },
  {
    id: 8,
    name: 'Cancelled',
    tlabel: 'INDENT_CANCELLED_STATUS',
  },
  {
    id: 25,
    name: 'Requested',
    tlabel: 'INDENT_REQUESTED_STATUS',
  },
  {
    id: 26,
    name: 'Container Picked',
    tlabel: 'INDENT_CONTAINER_PICKED_STATUS',
  },
  {
    id: 21,
    name: 'Acceptance Due',
    tlabel: 'INDENT_ACCEPTANCE_DUE_STATUS',
  },
  {
    id:11,
    name: 'Reported at destination',
    tlabel: 'INDENT_REPORTED_AT_DESTINATION_STATUS',
  },
  {
    id: 12,
    name: 'Unloading Started',
    tlabel: 'INDENT_UNLOADING_STARTED_STATUS',
  },
  {
    id: 39,
    name: 'Pending',
    tlabel: 'PENDING',
  },
];
// TODO NEED TO DO CHANGE IN REVAMP FOR HACH
export const packingIndentStatus = [
  {
    id: 0,
    name: 'Select All',
    tlabel: 'INDENT_ALL_STATUSES',
  },
  {
    id: 1,
    name: 'Indented',
    tlabel: 'INDENT_INDENTED_STATUS',
  },
  {
    id: 29,
    name: 'Ship Ready',
    tlabel: 'INDENT_SHIP_READY_STATUS',
  },
  {
    id: 30,
    name: 'Shipped',
    tlabel: 'INDENT_SHIPPED_STATUS',
  },
  {
    id: 7,
    name: 'Delivered',
    tlabel: 'INDENT_DELIVERED_STATUS',
  },
  {
    id: 8,
    name: 'Cancel',
    tlabel: 'INDENT_CANCEL_STATUS',
  },
  {
    id: 34,
    name: 'RESHIPPPED',
    tlabel: 'INDENT_RESHIPPED_STATUS',
  },
  {
    id: 35,
    name: 'RESHIP PROCESSING',
    tlabel: 'INDENT_RESHIP_PROCESSING',
  },
  {
    id: 36,
    name: 'RESHIP ERROR',
    tlabel: 'INDENT_RESHIP_ERROR',
  },
  {
    id: 39,
    name: 'PENDING',
    tlabel: 'PENDING',
  },
];

export const utilizationCheck = [
  {
    id: -1,
    name: 'All Checks',
    tlabel: 'INDENT_ALL_CHECKS',
  },
  {
    id: 2,
    label: 'Check',
    name: 'Check',
    tlabel: 'INDENT_CHECK',
  },
  {
    id: 3,
    label: 'Processed',
    name: 'Processed',
    tlabel: 'INDENT_PROCESSED',
  },
  {
    id: 4,
    label: 'Returned',
    name: 'Returned',
    tlabel: 'INDENT_RETURNED',
  },
];

export const searchParameters = [
  {
    id: 1,
    name: 'indent id',
    query: 'order_number',
    tname: 'INDENT_INDENT_ID',
  },
  {
    id: 2,
    name: 'carrier',
    query: 'transporter_name', // for internal reference
    show_feature: 'packing_indent',
    tname: 'INDENT_CARRIER',
  },
  {
    id: 3,
    name: 'transporter',
    query: 'transporter', // for internal reference
    currentQuerySelected: 'transporter_name', // hasdefaultquery option
    tname: 'INDENT_TRANSPORTER',
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Transporter Name',
        tname: 'INDENT_TRANSPORTER_NAME',
        query: 'transporter_name',
      },
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Transporter Ref id',
        tname: 'INDENT_TRANSPORTER_REF_ID',
        query: 'transporter_refId',
      },
    ],
    hide_feature: 'packing_indent',
  },
  {
    id: 4,
    name: 'vehicle number',
    query: 'vehicle_number',
    tname: 'INDENT_VEHICLE_NUMBER',
    hide_feature: 'packing_indent',
  },
  {
    id: 5,
    name: 'lr number',
    query: 'lr_number',
    tname: 'INDENT_LR_NUMBER',
    hide_feature: 'packing_indent',
  },
  {
    id: 6,
    name: 'customer',
    query: 'destination_consignee',
    placeholder: 'Consignee Name or Ref ID',
    tplaceholder: 'INDENT_CONSIGNEE_NAME_REF_ID',
    show_feature: 'packing_indent',
    tname: 'INDENT_CUSTOMER',
  },
  {
    id: 7,
    name: 'delivery number',
    query: 'material_ref_id',
    tname: 'INDENT_DELIVERY_NUMBER',
  },
];

export const outboundIndentParams = [
  {
    id: 9,
    name: 'drop off consignee',
    query: 'destination_consignee',
    tname: 'INDENT_DROP_OFF_CONSIGNEE',
    placeholder: ' Consignee Name, Ref ID or Material Invoice Number',
    tplaceholder: 'INDENT_CONSIGNEE_NAME_REF_ID',
    currentQuerySelected: 'destination_consignee_name', // defaultquery option
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Consignee Name',
        tname: 'INDENT_CONSIGNEE_NAME',
        query: 'destination_consignee_name',
      },
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Consignee Ref id',
        tname: 'INDENT_CONSIGNEE_REF_ID',
        query: 'destination_consignee_refId',
      },
    ],
    hide_feature: 'packing_indent',
  },
  {
    id: 10,
    name: 'drop off depot',
    query: 'destination_depot', // for internal reference
    tname: 'INDENT_DROP_OFF_DEPOT',
    placeholder: 'Depot Name or Ref ID',
    tplaceholder: 'INDENT_DEPOT_NAME_REF_ID',
    currentQuerySelected: 'destination_depot_name', // defaultquery option
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        tlabel: 'INDENT_IN_NAME',
        name: 'Drop off depot Name',
        tname: 'INDENT_DROP_OFF_DEPOT_NAME',
        query: 'destination_depot_name',
      },
      {
        label: 'in Ref id',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        tlabel: 'INDENT_IN_REF_ID',
        name: 'Drop off depot Ref id',
        tname: 'INDENT_DROP_OFF_DEPOT_REF_ID',
        query: 'destination_depot_refId',
      },
    ],
    hide_feature: 'packing_indent',
  },
  {
    id: 8,
    name: 'Other Info',
    query: 'other_info', // for internal reference
    tname: 'INDENT_OTHER_INFO',
    placeholder: 'Other Info',
    tplaceholder: 'INDENT_OTHER_INFO',
    currentQuerySelected: 'consignment_number', // defaultquery option
    multiDropDownQueryOptions: [
      {
        label: 'in Consignment no',
        tlabel: 'INDENT_IN_CONSIGNMENT_NO',
        name: 'Consignment no',
        tname: 'INDENT_CONSIGNMENT_NO',
        typeLabel: 'Consignment no',
        ttypeLabel: 'INDENT_CONSIGNMENT_NO',
        query: 'consignment_number',
      },
      { label: 'in Shipment no', name: 'Shipment no', typeLabel: 'Shipment no', query: 'shipment_number', config: 'isShipmentNumberEnabled' },
      { label: 'in Dock Ref', name: 'Dock Ref', typeLabel: 'Dock Ref', query: 'dock_ref' },
      {
        label: 'in Material invoice no',
        tlabel: 'INDENT_IN_MATERIAL_INVOICE_NO',
        typeLabel: 'Material invoice no',
        ttypeLabel: 'INDENT_MATERIAL_INVOICE_NO',
        name: 'Material invoice no',
        tname: 'INDENT_MATERIAL_INVOICE_NO',
        query: 'material_invoice_number',
      },
      {
        label: 'in Material Code',
        tlabel: 'INDENT_IN_MATERIAL_CODE',
        typeLabel: 'Material code',
        ttypeLabel: 'INDENT_IN_MATERIAL_CODE',
        name: 'Material code',
        tname: 'INDENT_IN_MATERIAL_CODE',
        query: 'material_code',
      },
    ],
  },
];

export const inboundIndentsParams = [
  {
    id: 9,
    name: 'source consignee',
    query: 'source_consignee',
    tname: 'INDENT_SOURCE_CONSIGNEE',
    placeholder: ' Consignee Name, Ref ID or Material Invoice Number',
    tplaceholder: 'INDENT_CONSIGNEE_NAME_REF_ID',
    currentQuerySelected: 'source_consignee_name', // defaultquery option
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Consignee Name',
        tname: 'INDENT_CONSIGNEE_NAME',
        query: 'source_consignee_name',
      },
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Consignee Ref id',
        tname: 'INDENT_CONSIGNEE_REF_ID',
        query: 'source_consignee_refId',
      },
    ],
    hide_feature: 'packing_indent',
  },
  {
    id: 10,
    name: 'source depot',
    query: 'source_depot', // for internal reference
    tname: 'INDENT_SOURCE_VENDOR_DEPOT',
    placeholder: 'Depot Name or Ref ID',
    tplaceholder: 'INDENT_DEPOT_NAME_REF_ID',
    currentQuerySelected: 'transporter_name', // defaultquery option
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        tlabel: 'INDENT_IN_NAME',
        name: 'Source depot Name',
        tname: 'INDENT_SOURCE_DEPOT_NAME',
        query: 'source_depot_name',
      },
      {
        label: 'in Ref id',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        tlabel: 'INDENT_IN_REF_ID',
        name: 'Source depot Ref id',
        tname: 'INDENT_SOURCE_DEPOT_REF_ID',
        query: 'source_depot_refId',
      },
    ],
    hide_feature: 'packing_indent',
  },
  {
    id: 8,
    name: 'Other Info',
    query: 'other_info', // for internal reference
    tname: 'INDENT_OTHER_INFO',
    placeholder: 'Other Info',
    tplaceholder: 'INDENT_OTHER_INFO',
    currentQuerySelected: 'consignment_number', // defaultquery option
    multiDropDownQueryOptions: [
      {
        label: 'in Consignment no',
        tlabel: 'INDENT_IN_CONSIGNMENT_NO',
        name: 'Consignment no',
        tname: 'INDENT_CONSIGNMENT_NO',
        typeLabel: 'Consignment no',
        ttypeLabel: 'INDENT_CONSIGNMENT_NO',
        query: 'consignment_number',
      },
      { label: 'in Shipment no', name: 'Shipment no', typeLabel: 'Shipment no', query: 'shipment_number', config: 'isShipmentNumberEnabled' },
      { label: 'in Dock Ref', name: 'Dock Ref', typeLabel: 'Dock Ref', query: 'dock_ref' },
      {
        label: 'in Material invoice no',
        tlabel: 'INDENT_IN_MATERIAL_INVOICE_NO',
        typeLabel: 'Material invoice no',
        ttypeLabel: 'INDENT_MATERIAL_INVOICE_NO',
        name: 'Material invoice no',
        tname: 'INDENT_MATERIAL_INVOICE_NO',
        query: 'material_invoice_number',
      },
      {
        label: 'in Material Code',
        tlabel: 'INDENT_IN_MATERIAL_CODE',
        typeLabel: 'Material code',
        ttypeLabel: 'INDENT_IN_MATERIAL_CODE',
        name: 'Material code',
        tname: 'INDENT_IN_MATERIAL_CODE',
        query: 'material_code',
      },
    ],
  },
];

export const blacklistStatusList = [
  { id: BlacklistStatus.BLACKLIST, name: 'Blacklist', tlabel: 'INDENT_BLACKLIST' },
  { id: BlacklistStatus.UNBLACKLIST, name: 'Unblacklist', tlabel: 'INDENT_UNBLACKLIST' },
];

export const controlTowerParameters = {
  reindentPendingIndents: 'REINDENT PENDING INDENTS',
  inboundPendingIndents: 'INBOUND PENDING INDENTS',
  inboundCompletedIndents: 'INBOUND COMPLETED INDENTS',
  outboundPendingIndents: 'OUTBOUND PENDING INDENTS',
  outboundCompletedIndents: 'OUTBOUND COMPLETED INDENTS',
  transitDelayedIndents: 'TRANSIT DELAYED INDENTS',
  arrivalDelayedIndents: 'ARRIVAL DELAYED INDENTS',
  acceptanceDelayedIndents: 'ACCEPTANCE DELAYED INDENTS',
  vehicleChangeRequestedIndents: 'VEHICLE CHANGE REQUESTED INDENTS',
  openFreightChargeMissingIndents: 'OPEN FREIGHT CHARGE MISSING INDENTS',
  meterialInvoiceNAIndents: 'MATERIAL INVOICE NA INDENTS',
  quoteApprovalPendingIndents: 'QUOTE APPROVAL PENDING INDENTS',
  grnApprovalPendingIndents: 'GRN APPROVAL PENDING INDENTS',
  utilizationCheckPendingIndents: 'UTILIZATION CHECK PENDING INDENTS',
};

export const sortOptions = [
  {
    key: 'indent_id',
    sort_options: [
      {
        name: 'Indent Id',
        sort_by_filter: { created_at: 'desc' },
      },
    ],
  },
];

export const cmtValue = 35.315;

export const filterOptions = [
  { id: 'gate_pass', name: 'Gate pass', tlabel: 'INDENT_GATE_PASS', query: 'gate_pass_given' },
  { id: 'gate_pass_na', name: 'Gate pass N/A', tlabel: 'INDENT_GATE_PASS_NA', query: 'gate_pass' },
];

export const indentActions = {
  ASSIGN_TRUCK: 'ASSIGN_TRUCK',
  UPDATE_TRUCK: 'UPDATE_TRUCK',
  QUOTES: 'QUOTES',
  MARK_AS_DELIVERED: 'MARK_AS_DELIVERED',
  START_LOAD: 'START_LOAD',
  END_LOAD: 'END_LOAD',
  TRUCKIN: 'TRUCKIN',
  TRUCKOUT: 'TRUCKOUT',
  FREIGHT: 'FREIGHT',
  LAST_MILE_ACTIONS: 'LAST_MILE_ACTIONS',
  UPDATE_VEHICLE_TYPE: 'UPDATE_VEHICLE_TYPE',
};

export const gstList = [
  { value: 1, label: 'FCM' },
  { value: 2, label: 'RCM' },
];

export const indentFCMActions = {
  INDENT_STATUS_UPDATE: 'INDENT_STATUS_UPDATE',
};

export const oneDayMilliSeconds = 8.64e7;

export const materialPriorityList = [
  {
    id: -1,
    name: 'All Material Priorities',
    tlabel: 'INDENT_ALL_MATERIAL_PRIORITY',
  },
];

export const routerSourceAndDestinationType = {
  DEPOT: 1,
  CONSIGNEE: 2,
  VENDOR_DEPOT: 3,
  PORT: 4,
  NO_MASTER_ENTITY: 5,
  GATE: 6,
};


export const reIndentReasonOptions = [{
  value: 'Lack of availability of truck with transporter',
  key: 'TRANSPORTER_NOT_AVAILABLE',
},
{
  value: 'No Response from transporter',
  key: 'TRANSPORTER_NOT_RESPONSIVE',
},
{
  value: 'Transporter doesn’t agree on contracted rate and wants to renegotiate',
  key: 'TRANSPORTER_RENEGOTIATED',
},
{
  value: 'Others',
  key: 'OTHERS',
},
];
